import { diff } from "deep-object-diff";
import { Response } from "@angular/http";
import { IUri } from "../../interfaces/interfaces";
import { cleanObjectForDiff } from "../../util/utils";

export const parseLocation = (response: Response): IUri => {
    if (!response.headers.get("Location")) {
        throw new Error("Location is missing");
    }

    const parts = response.headers
        .get("Location")
        .replace("/app_dev.php", "")
        .replace("/api/v1", "")
        .replace(/^\//, "")
        .split("/");

    return {
        account: parts[1],
        resource: parts[2],
        resourceId: parts[3],
        subResource: parts[4],
        subResourceId: parts[5]
    };
};

export class DiffHelper {

    static doDiffsConflict(objA: any, objB: any): boolean {

        let key: string;
        let valA: any;
        let valB: any;

        objA = DiffHelper.cleanObjectForDiff(objA);
        objB = DiffHelper.cleanObjectForDiff(objB);

        if (Array.isArray(objA) && Array.isArray(objB) && objA.length !== objB.length) {
            return true;
        }

        if (objB === undefined) {
            return false;
        }

        if (typeof objA === "object") {
            for (key in objA) {

                if (!objA.hasOwnProperty(key)) continue;

                // special case - handle array diff
                if (!Array.isArray(objA) && !isNaN(parseInt(key, 10))) {
                    // if there are any keys in b this is a conflict
                    if (objB !== undefined && Object.keys(objB).length) {
                        return true;
                    }
                }

                valA = objA[key];
                valB = objB[key];

                if (DiffHelper.doDiffsConflict(valA, valB)) {
                    return true;
                }
            }
        } else {
            if (objB === undefined) {
                return false;
            }
            return (objA ? objA.toString() : undefined) !== (objB ? objB.toString() : undefined);
        }
        return false;
    }

    static cleanObjectForDiff(object: any): any {
        return cleanObjectForDiff(object);
    }

    static intersectPropertyName(a: any, b: any): Array<string> {
        return Object.keys(a)
            .filter(key => Object.keys(b).indexOf(key) !== -1);
    }

    static diff(a: any, b: any): any {
        return diff(a, b);
    }
}



// WEBPACK FOOTER //
// ./src/core/services/sync-up/helpers.ts